import React, { createContext, useContext } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GamePassConfig } from '../types';

interface GamePassContextType extends GamePassConfig {}

const GamePassContext = createContext<GamePassContextType | null>(null);

export const useGamePass = () => {
  const context = useContext(GamePassContext);
  if (!context) {
    throw new Error('useGamePass must be used within GamePassProvider');
  }
  return context;
};

interface GamePassProviderProps extends GamePassConfig {
  children: React.ReactNode;
}

export const GamePassProvider: React.FC<GamePassProviderProps> = ({
  children,
  googleClientId,
  onSuccess,
  onError,
}) => {
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <GamePassContext.Provider value={{ googleClientId, onSuccess, onError }}>
        {children}
      </GamePassContext.Provider>
    </GoogleOAuthProvider>
  );
};